module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Black.3ca84e290657aa3753f52fe14a69f17c.woff";